/**
 * Moldura da abertura por serviço (E126.F2): o título da tela e as etapas, iguais no portal e na
 * área do perito. Cada passo decide o próprio título (o de Arquivos diz o que enviar).
 */
import type { ReactNode } from 'react';

import { ptBR } from '@/i18n/pt-BR';
import type { PassoDaAbertura } from '@/lib/abertura';

import { AberturaStepper } from './AberturaStepper';

const t = ptBR.abertura;

export interface AberturaFrameProps {
  passo: PassoDaAbertura;
  titulo?: string;
  subtitulo?: string;
  /** E163.F3: o rótulo acima do título; a consulta de custódia diz "Material / Custódia". */
  eyebrow?: string;
  /** E163.F3: a consulta de custódia não é etapa da jornada e não mostra as etapas. */
  semEtapas?: boolean;
  children: ReactNode;
}

export function AberturaFrame({
  passo,
  titulo = t.titulo,
  subtitulo = t.subtitulo,
  eyebrow = t.eyebrow,
  semEtapas = false,
  children,
}: AberturaFrameProps): JSX.Element {
  return (
    <section
      className="mx-auto max-w-5xl"
      aria-labelledby="abertura-titulo"
      data-testid="abertura-page"
      data-passo={passo}
      data-vista={semEtapas ? 'custodia' : undefined}
    >
      {/* E165.F1.T03 (HTML 6.8): o rótulo em IBM Plex Mono 12px, o título em Spectral 28px (25px no
          estreito) e o subtítulo só quando há um. */}
      <header className="border-b border-fg">
        <p className="font-titulo text-rotulo uppercase text-accent-700">{eyebrow}</p>
        <h1
          id="abertura-titulo"
          className="mb-[9px] mt-2 font-display text-titulo-pagina text-fg max-[700px]:text-[25px]"
        >
          {titulo}
        </h1>
        {subtitulo !== '' ? (
          <p className="mb-5 max-w-[70ch] text-corpo text-fg-muted">{subtitulo}</p>
        ) : (
          <div className="mb-5" />
        )}
      </header>
      {semEtapas ? (
        <div className="mt-[22px]" />
      ) : (
        <div className="mb-6 mt-[22px]">
          <AberturaStepper passoAtual={passo} />
        </div>
      )}
      {children}
    </section>
  );
}
